export default __webpack_public_path__ + "static/xcad-mono-gray-e3157ba5879762acfbce268d9de9d50e.svg";